/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import moment from 'moment-timezone';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';
import { showWarningToast } from '../../../../shared/utils/toastManager';
import {
  setSelectedStartDayOfWeek,
  setSelectedNumberOfDaysToShowInWeek,
  setSelectedDaysOfWeekToShowInCurrentWeek,
  setGroupByFilter,
} from '../../ducks/calendarActions';
import usePreSaveNavigationGuard from '../../hooks/usePreSaveNavigationGuard';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 4px;
  border-radius: 6px;
  box-shadow: 0 16px 24px 0 rgba(48, 49, 51, 0.10), 0 0 1px 0 rgba(48, 49, 51, 0.05);
  left: ${(props) => props.left || 0}px;
  top: ${(props) => props.top || 0}px;
  gap: 4px;
  overflow-y: auto;
  min-width: 195px;
  max-width: 200px;
`;

const Option = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  cursor: pointer;
  background: white;
  border: 1px solid transparent;

  &:hover {
    background: #FCFCFC;
  }
`;

const CustomDivider = styled.div`
  height: 1px;
  margin: 0;
  background-color: #EEEEEE;
  margin-left: 10px;
  margin-right: 10px;
`;

const HeaderSubMenuPopup = ({
  left,
  top,
  openTop = false,
  spaceAbove = null,
  menuType = 'Start Week On',
}) => {
  const dispatch = useDispatch();
  const guardNavigation = usePreSaveNavigationGuard();
  const containerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('none');
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const calendarContainerScrollPosition = useSelector((state) => state.calendar.data.calendarContainerScrollPosition);
  const currentlyDisplayedWeekdays = useSelector((state) => state.calendar.data.currentlyDisplayedWeekdays);
  const selectedStartDayOfWeek = useSelector((state) => state.calendar.data.selectedStartDayOfWeek);
  const selectedNumberOfDaysToShowInWeek = useSelector(
    (state) => state.calendar.data.selectedNumberOfDaysToShowInWeek,
  );
  const selectedDaysOfWeekToShowInCurrentWeek = useSelector(
    (state) => state.calendar.data.selectedDaysOfWeekToShowInCurrentWeek,
  );
  const groupByFilter = useSelector(
    (state) => state.calendar.data.groupByFilter,
  );
  const selectedWeekViewDayToggle = useSelector(
    (state) => state.calendar.data.selectedWeekViewDayToggle,
  );
  const selectedReduxCalendar = useSelector((state) => state.calendar.data.selectedReduxCalendar);
  const selectedReduxAthlete = useSelector((state) => state.calendar.data.selectedReduxAthlete);
  const nonDateBasedProgramItems = useSelector((state) => state.calendar.data.nonDateBasedProgramItems);

  const menuOption = menuType === 'Number of Days' ? selectedNumberOfDaysToShowInWeek : menuType === 'Show' ? selectedDaysOfWeekToShowInCurrentWeek : menuType === 'Group By' ? groupByFilter : selectedStartDayOfWeek;

  const formattedDate = moment(selectedDate).format('YYYY-MM-DD');

  const numberOfTimesSelectedDayOccursInMonth = () => {
    const start = moment(formattedDate).startOf('month');
    const end = moment(formattedDate).endOf('month');

    const countDays = (day) => (day.isAfter(end, 'day')
      ? 0
      : (day.format('dddd') === selectedWeekViewDayToggle ? 1 : 0) + countDays(day.clone().add(1, 'day')));

    return countDays(start);
  };

  useEffect(() => {
    const updateMaxHeight = () => {
      if (containerRef?.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.top - 10; /** 10px padding from bottom */
        setMaxHeight(spaceBelow);
      }
    };

    /** Initial set */
    updateMaxHeight();

    /** Add listener */
    window.addEventListener('resize', updateMaxHeight);

    /** Cleanup */
    return () => {
      window.removeEventListener('resize', updateMaxHeight);
    };
  }, [calendarContainerScrollPosition]);

  const nonEmptyDaysRemaining = () => {
    const calendarItemsForToggledOnDays = currentlyDisplayedWeekdays.filter((item) => item.isDateEmpty === false);

    return calendarItemsForToggledOnDays?.length;
  };

  const showArray = nonEmptyDaysRemaining() >= 2 || (!Object.keys(selectedReduxCalendar).length && !Object.keys(selectedReduxAthlete).length) ? [
    'Empty Days',
    'Weekends',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ] : [
    'Weekends',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const groupByArray = ['Week', 'Day'];

  const numberOfDaysArray = selectedWeekViewDayToggle === 'Everyday' ? [
    2, 3, 4, 5, 6, 7,
  ] : Array.from(
    { length: numberOfTimesSelectedDayOccursInMonth() - 1 },
    (_, i) => i + 2,
  );

  const getLastWeekNumberInProgram = () => {
    if (!nonDateBasedProgramItems) return null;

    const itemsArray = Array.isArray(nonDateBasedProgramItems)
      ? nonDateBasedProgramItems
      : Object.values(nonDateBasedProgramItems);

    if (itemsArray.length === 0) return null;

    return itemsArray.reduce(
      (max, item) => (item.weekNumber > max ? item.weekNumber : max),
      0,
    );
  };
  const lastWeekNumberInProgram = getLastWeekNumberInProgram();
  const generateNumberArray = (n) => Array.from({ length: n }, (_, i) => i + 1);

  const numberOfDaysArrayForNonDateBased = groupByFilter === 'Week' ? [1, 2, 3, 4, 5, 6, 7] : generateNumberArray(lastWeekNumberInProgram);

  const menuOptions = menuType === 'Number of Days' ? (programType === 'free-form-program' ? numberOfDaysArrayForNonDateBased : numberOfDaysArray) : menuType === 'Show' ? showArray : menuType === 'Group By' ? groupByArray : [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
  ];

  const getEffectiveSelectedDaysCount = (selection) => {
    const weekdays = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    const effectiveDays = [];

    /** Add selected weekdays */
    weekdays.forEach((day) => {
      if (selection.includes(day)) {
        effectiveDays.push(day);
      }
    });

    const hasWeekends = selection.includes('Weekends');
    const hasSaturday = selection.includes('Saturday');
    const hasSunday = selection.includes('Sunday');

    /** Handle weekend days: */
    if (hasWeekends) {
    /** If Saturday is NOT explicitly toggled off, count it */
      if (!selection.includes('Saturday')) {
        effectiveDays.push('Saturday');
      }
      if (!selection.includes('Sunday')) {
        effectiveDays.push('Sunday');
      }
    }

    /** Now add any explicitly selected weekend days not already counted */
    if (hasSaturday && !effectiveDays.includes('Saturday')) {
      effectiveDays.push('Saturday');
    }
    if (hasSunday && !effectiveDays.includes('Sunday')) {
      effectiveDays.push('Sunday');
    }

    return effectiveDays.length;
  };

  const handleClick = (option) => {
    if (menuType === 'Start Week On') {
      dispatch(setSelectedStartDayOfWeek(option));
      return;
    }

    if (menuType === 'Number of Days') {
      dispatch(setSelectedNumberOfDaysToShowInWeek(option));
      return;
    }
    if (menuType === 'Group By') {
      guardNavigation(() => {
        dispatch(setGroupByFilter(option));
      });
      return;
    }

    if (menuType === 'Show') {
      const wasSelected = selectedDaysOfWeekToShowInCurrentWeek.includes(option);
      let updatedSelection = [...selectedDaysOfWeekToShowInCurrentWeek];

      const weekendDays = ['Saturday', 'Sunday'];
      const isWeekendToggle = option === 'Weekends';
      const isEmptyDaysToggle = option === 'Empty Days';

      const getDayName = (dateStr) => moment(dateStr).format('dddd').toLowerCase();

      const emptyDayNames = currentlyDisplayedWeekdays
        .filter((day) => day.isDateEmpty)
        .map((day) => getDayName(day.date));

      if (isEmptyDaysToggle) {
        if (wasSelected) {
        /** Remove 'Empty Days' toggle and all empty days */
          updatedSelection = updatedSelection.filter(
            (item) => item.toLowerCase() !== 'empty days' && !emptyDayNames.includes(item.toLowerCase()),
          );

          /** Remove 'Weekends' toggle if Saturday or Sunday removed */
          const hasSat = updatedSelection.includes('Saturday');
          const hasSun = updatedSelection.includes('Sunday');
          if (!hasSat || !hasSun) {
            updatedSelection = updatedSelection.filter((item) => item !== 'Weekends');
          }
        } else {
        /** Add all empty days and 'Empty Days' */
        /** commenting out this code for now -- might need it after testing some more
          emptyDayNames.forEach((day) => {
            const capDay = day.charAt(0).toUpperCase() + day.slice(1);
            if (!updatedSelection.includes(capDay)) updatedSelection.push(capDay);
          });
          if (!updatedSelection.includes('Empty Days')) updatedSelection.push('Empty Days');
          */
          updatedSelection = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'Empty Days', 'Weekends'];
        }
      } else if (isWeekendToggle) {
        /** Always add 'Empty Days' toggle when toggling any day ON */
        if (!updatedSelection.includes('Empty Days')) {
          updatedSelection.push('Empty Days');
        }
        const weekendItems = [...weekendDays, 'Weekends'];
        if (wasSelected) {
          updatedSelection = updatedSelection.filter((item) => !weekendItems.includes(item));
        } else {
          weekendItems.forEach((item) => {
            if (!updatedSelection.includes(item)) updatedSelection.push(item);
          });
        }
      } else if (wasSelected) {
      /** Toggle individual day OFF */
        updatedSelection = updatedSelection.filter((item) => item !== option);

        /** Auto-remove 'Weekends' if weekend days broken */
        if ((option === 'Saturday' || option === 'Sunday') && updatedSelection.includes('Weekends')) {
          const hasSat = updatedSelection.includes('Saturday');
          const hasSun = updatedSelection.includes('Sunday');
          if (!hasSat || !hasSun) {
            updatedSelection = updatedSelection.filter((item) => item !== 'Weekends');
          }
        }

        /** Remove 'Empty Days' toggle if no empty days remain selected */
        const stillHasEmptyDays = updatedSelection.some((item) => emptyDayNames.includes(item.toLowerCase()));
        if (!stillHasEmptyDays) {
          updatedSelection = updatedSelection.filter((item) => item.toLowerCase() !== 'empty days');
        }
      } else {
      /** Toggle individual day ON */
        if (!updatedSelection.includes(option)) {
          updatedSelection.push(option);
        }

        /** Always add 'Empty Days' toggle when toggling any day ON */
        if (!updatedSelection.includes('Empty Days')) {
          updatedSelection.push('Empty Days');
        }

        /** Auto-add 'Weekends' if both weekend days selected */
        if ((option === 'Saturday' || option === 'Sunday') && !updatedSelection.includes('Weekends')) {
          const hasSat = updatedSelection.includes('Saturday');
          const hasSun = updatedSelection.includes('Sunday');
          if (hasSat && hasSun) {
            updatedSelection.push('Weekends');
          }
        }
      }

      /** Validate minimum 2 real days selected BEFORE dispatching */
      const effectiveDays = getEffectiveSelectedDaysCount(updatedSelection);
      if (effectiveDays < 2) {
        showWarningToast('At least 2 days must be selected');
        return;
      }

      dispatch(setSelectedDaysOfWeekToShowInCurrentWeek(updatedSelection));
    }
  };

  return (
    <Container
      ref={containerRef}
      onClick={(e) => {
        e.stopPropagation();
      }}
      left={left}
      top={top}
      style={{ maxHeight: openTop ? spaceAbove : maxHeight }}
    >
      {menuOptions?.map((option) => (
        <React.Fragment key={option}>
          <Option
            key={option}
            onClick={() => handleClick(option)}
          >
            <Text
              fontSize='16px'
            >
              {option}
            </Text>
            {(menuType === 'Show'
              ? selectedDaysOfWeekToShowInCurrentWeek.includes(option)
              : menuOption === option) && (
              <IcomoonReact
                iconSet={iconSet}
                size={16}
                icon='checkmark'
                color='#9E9E9E'
              />
            )}
          </Option>
          {option === 'Weekends' && (
          <CustomDivider />
          )}
        </React.Fragment>
      ))}
    </Container>
  );
};

export default HeaderSubMenuPopup;
